import {post} from './httpBase'
export function translate(params) {
    return post('/order/order/translate', params)
}
//获取当前调度人信息
export function dispatcher(params) {
    return post('/user/dispatcher/current', params)
}
//获取城际行程列表
export function current(params) {
    return post('/line/shift/list', params)
}
//获取代下单记录
export function getOrderList(params) {
    return post('/order/intercity/assitorder/list', params)
}
//取消行程
export function deleteShift(params) {
    return post('/line/shift/delete', params)
}
//分流工作台
export function shuntOrder(params) {
    return post('/order/manageshuntorder/shuntorderinquiry', params)
}
//获取代下单详情
export function getOrderInfo(params) {
    return post('/order/intercity/assistorder/detail', params)
}
//修改上下车地址
export function changeAddress(params) {
    return post('/order/shuntorder/changeaddressofshuntorder', params)
}
//修改上下车地址获取差价
export function getcharge(params) {
    return post('/order/shuntorder/getpriceofaddresschange', params)
}
//获取分流订单列表
export function getshuntList(params) {
    return post('/order/manageshuntorder/dispatchershuntorderlist', params)
}
//获取分流组合后订单的列表
export function shuntList(params) {
    return post('/order/shuntorder/dispacherofshuntorderrecrod', params)
}
//消息列表
export function NewList(params) {
    return post('/order/shuntorder/messagerecord', params)
}
//选择地址的时候判断是否在接送范围内
export function isDelivery(params) {
    return post('/line/station/check', params)
}
//虚拟通话
export function fakeConverse(params) {
    return post('/order/phonevirtual/callpassenger', params)
}
//分流订单的虚拟通话
export function shuntFakeConverse(params) {
    return post('/order/phonevirtual/shuntmangerorder', params)
}
//城内列表
export function cityList(params) {
    return post('/order/cityorder/dispatchercityorderlisthis', params)
}


//判断绑定司机保险信息是否过期
export function checkDriverInsurance(params) {
    return post('/user/driver/insurancecheckdis', params)
}

//2021-10-18新增自检单审核
export function selfdislist(params) {
    return post('/user/self/selfdislist', params)
}
export function disaudit(params) {
    return post('/user/self/disaudit', params)
}

export function dispatcherlist(params) {
    return post('/line/shift/dispatcherlist', params)
}


// WEBPACK FOOTER //
// ./src/service/homeService.js